//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../axios/axios.js'

import DateTimeField from '../../components/Field/DateTimeField.vue'
import WarningBanner from '../../components/WarningBanner.vue'

export default {
  components: {
    DateTimeField,
    WarningBanner
  },
  props: {
    requestId: {
      type: Number,
      default: null
    },
    createTime: {
      type: Number,
      default: null
    },
    reportDocuments: {
      type: Array,
      default: () => []
    },
    configMode: {
      type: Boolean,
      default: false
    },
    showSkipBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const reportDocumentsLocal = []
    this.reportDocuments.forEach((reportDocument, index) => {
      reportDocumentsLocal.push({
        id: reportDocument.id || null,
        index,
        name: reportDocument.name,
        creationTime: reportDocument.creationTime || reportDocument.createTime || null
      })
    })

    return {
      requestTime: null,
      reportDocumentsLocal,

      numberChangeRequired: false,
      warnings: [
        'Форма в процессе разработки.',
        'Отменить действие полностью пока нельзя, будьте осторожны выбирая заявку для изменения.',
        'Изменяется только дата, время можно указать любое.'
      ]
    }
  },
  watch: {
    requestTime () {
      this.$nextTick(() => this.revalidateAll())
    },
    reportDocumentsLocal: {
      handler () {
        this.$nextTick(() => this.revalidateAll())
      },
      deep: true
    }
  },
  created: function () {
    this.requestTime = this.createTime
    this.numberChangeRequired = false
  },
  methods: {
    getAllTimes: function () {
      const times = []

      if (this.requestTime != null) {
        times.push({
          type: 'request',
          value: this.requestTime != null ? Number(this.requestTime) : null
        })
      }

      if (this.reportDocumentsLocal && this.reportDocumentsLocal.length) {
        this.reportDocumentsLocal.forEach((doc, index) => {
          times.push({
            type: 'report',
            index,
            value: doc.creationTime != null ? Number(doc.creationTime) : null
          })
        })
      }

      return times
    },
    validateTimeOrder: function (currentType, currentIndex = null) {
      return () => {
        const times = this.getAllTimes()

        const currentPosition = times.findIndex(item => {
          return (
            (currentType === 'request' && item.type === 'request') ||
        (currentType === 'report' && item.type === 'report' && item.index === currentIndex)
          )
        })

        if (currentPosition === -1) {
          return true
        }

        const current = times[currentPosition]

        if (!current || current.value == null) {
          return true
        }

        const prev = times[currentPosition - 1]

        if (prev && prev.value != null && current.value < prev.value) {
          return 'Дата/время должны быть больше предыдущих'
        }

        return true
      }
    },
    revalidateAll () {
      if (this.$refs.dateTimeField) {
        if (Array.isArray(this.$refs.dateTimeField)) {
          this.$refs.dateTimeField.forEach(ref => ref.validate && ref.validate())
        } else {
          this.$refs.dateTimeField.validate && this.$refs.dateTimeField.validate()
        }
      }
    },
    onApply: function () {
      if (this.configMode) {
        this.onConfirm()
      } else {
        this.onSave()
      }
    },
    getConfig: function () {
      const config = {}
      config.request = this.requestId
      config.numberChangeRequired = !!this.numberChangeRequired
      config.requestTime = this.requestTime

      if (this.reportDocumentsLocal && this.reportDocumentsLocal.length) {
        const reportsTimes = []
        this.reportDocumentsLocal.forEach((reportDocument, index) => {
          if (reportDocument.creationTime != null) {
            reportsTimes.push({
              id: reportDocument.id || null, //
              index, //
              time: reportDocument.creationTime //
            })
          }
        })
        if (reportsTimes.length) {
          config.reportsTimes = reportsTimes
        }
      }
      return config
    },
    onConfirm: function () {
      const config = this.getConfig()
      this.$emit('confirm', config)
    },
    onSave: function () {
      const config = this.getConfig()
      const bodyFormData = new FormData()
      bodyFormData.set('request', config.request)
      bodyFormData.set('requestTime', config.requestTime)
      bodyFormData.set('numberChangeRequired', config.numberChangeRequired)
      if (config.reportsTimes) {
        bodyFormData.set('reportsTimes', JSON.stringify(config.reportsTimes))
      }

      return axiosPost({
        url: '/service/delta/requestBusinessProcess/special/changeTime',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Изменения успешно применены',
            progress: true,
            timeout: 3000
          })

          this.$emit('success')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(response.message))
        }
      })
    },
    onSkip: function () {
      this.$emit('confirm', null)
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}
